import React from "react";
import { useDispatch, useSelector } from "react-redux";
import constants from "../assets/js/constants";
import { socialIcons } from "../assets/js/images";
import { toggleLanguage } from "../store/auxiliary/ui/generalSettings";
import LanguageToggler from "./LanguageToggler";
import NavbarList from "./NavbarList";
import SocialMedia from "./SocialMedia";
import content from "../assets/content/content.json";

function MenuOpen({
  onPressMenuItem,
  onPressCloseMenu,
  visible,
  onPressLanguageToggler,
}) {
  const generalSettings = useSelector((state) => state.ui.generalSettings);
  const dispatch = useDispatch();
  // const handleLanguageToggler = () => {
  //   dispatch(toggleLanguage());
  //   if (!generalSettings.rtlLanguage) {
  //     constants.ROOT_ELEMENT.dataset.languageDirection = "right";
  //   } else {
  //     delete constants.ROOT_ELEMENT.dataset.languageDirection;
  //   }
  // };

  return visible ? (
    <article className="menu-open">
      <div className="menu-open__header">
        <LanguageToggler
          rtl={generalSettings.rtlLanguage}
          // onPress={handleLanguageToggler}
          onPress={onPressLanguageToggler}
          applyClassName="border-white"
        />
        <span className="menu-open__close-icon" onClick={onPressCloseMenu}>
          x
        </span>
      </div>
      <NavbarList onPressMenuItem={onPressMenuItem} />
      <SocialMedia
        socialMediaIcons={socialIcons}
        socialMediaItems={content.socialMedia}
      />
    </article>
  ) : null;
}

export default MenuOpen;
